<template>

    <body id="main">
        <section class="container-fluid">
            <div class="row mcas">
                <div class="col-md-6 col-lg-4 main lr" id="mlrp">
                    <div class="row nav-top">
                        <div class="col-8 ddavc"><span class="nav-back wt" id="back" onclick=""></span><span
                                class="tfw-5 tf-18" id="navNam">Login</span></div>
                    </div>
                    <div class="row">
                        <div class="col-12 pt-4 xtc" id="cimg"><img src="../assets/logo.png" height="170"></div>
                        <div class="col-12" id="vrgj89b">
                            <div class="row">
                                <div class="col-12">
                                    <div class="row mr-0 pt-1">
                                        <div class="col-12 inpbcx"><span class="xicon cell"></span> <input type="tel"
                                                class="xbox" v-model="user.username" @input="check()" id="emob" maxlength="10"
                                                placeholder="Enter Mobile Number" autocomplete="off"></div>
                                        <div class="col-12 inpbcx" id="elpsh78" style=""><span
                                                class="xicon lock"></span> <input class="xbox pin" v-model="user.password" @input="check()"
                                                id="epass" maxlength="21" placeholder="Password (≥6 characters)"
                                                autocomplete="off"></div>
                                        <div class="col-12 pa-0 xtl dipn" id="ero89bj" style="display: none;">
                                            <div class="inpbcx"><span class="xicon key"></span> <input type="tel"
                                                    class="xbox" oninput="lnxG()" id="eotp" maxlength="6"
                                                    placeholder="Verification Code" autocomplete="off"
                                                    onkeydown="lgenk()"> <span class="GOTP" onclick="GOTP()"
                                                    id="GOTP">OTP</span></div>
                                        </div>
                                        <div class="col-12 pa-0 pt-1 ml-2 mb-2 tfcdb tf-16 xtl" id="remmc"><span
                                                class="dipn"><input type="checkbox" id="ccbox" checked=""></span> <span
                                                class="tfcsdb dipn">Remeber Me</span></div>
                                        <div class="col-12 pa-0 mt-2 mb-3">
                                            <div class="btn-main"  @click="onLogin()" id="lnxG">Login </div>
                                            <div class="btn-main act" style="display:none" id="load"><img class='spin'  src='../assets/includes/images/loader.png' style="height: 28px"></div>
                                        </div>
                                        <div class="col-6 tf-18 pa-0 mt-2 mb-2" id="canac">
                                            <div class="mcpl srm67b" onclick="window.location.href='#/register'">Create
                                                an account</div>
                                        </div>
                                        <div class="col-6 xtr pt-2 pb-2 pr-0" id="qlt">
                                            <div class="mcpl srm67b" id="vgh79"
                                                onclick="window.location.href='https://t.me/telegram_here'">Forgot Password?</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" id="dta_ref">
                        <div class="col-12 conod LR" @click="clink" id="clink" style="display :none;">
                            <div class="ssmg fadein" >
                                <div class="tf-14" id="smgid">Password error, Please check</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </body>
</template>
<script>

import axios from "axios";
export default {
    name: "LoginView",
    data() {
        return {
            login:false,
            user: {
                username: null,
                password: null
            }
        }

    },
    beforeCreate: function () {
        if (localStorage.getItem('username') != null)
            this.$router.push({ name: '/' });
    },
    methods: {
        pop(message) {
            document.getElementById("smgid").innerHTML = message;
            document.getElementById("clink").style.display = "";
            this.stopspin();
        },
        spin(){
            console.log("load");
            document.getElementById("lnxG").style.display = "none";
            document.getElementById("load").style.display = "";   
        },
        stopspin() {
            document.getElementById("lnxG").style.display = "";
            document.getElementById("load").style.display = "none";
            
        },
        clink(){
            document.getElementById("clink").style.display = "none";
        },
        check() {
            if (document.getElementById("emob").value.length == 10 && document.getElementById("epass").value.length > 5) {
                document.getElementById("lnxG").className = "btn-main act";
                this.login=true;
            } else {
                document.getElementById("lnxG").className = "btn-main";
                this.login=false;
            }
        },
        onLogin() {
            if(this.login==true){
                this.spin();
          
                var data = new FormData();
                data.append("username", this.user.username);
                data.append("password", this.user.password);
                axios
                    .post(
                        "https://fiewin.source-code.co.in/Gameapi/src/api/userapi.php?action=login",
                        data
                    )
                    .then(res => {
                        if (res.data.error) {
                            console.log("Error", res.data);
                            this.pop(res.data.message);
                        } else {  
                            localStorage.setItem('username', this.user.username);
                            localStorage.setItem('note', false);
                            console.log("Success", res.data.message);
                            setTimeout(() => { this.$router.push("/"); }, 600);

                        }
                    })
                    .catch(err => {
                        console.log("Error", err);
                    });
            
            }
           
        },
        redirect() {
            console.log(this.$store.state.name);
            //this.$router.push({ name: 'Search' });
        },




    }




}
</script>
